import { FirebaseApp, FirebaseOptions, initializeApp } from "@firebase/app";
import { Auth, browserLocalPersistence, initializeAuth } from "@firebase/auth";

import { Database, getDatabase } from "@firebase/database";
import { Firestore, getFirestore } from "@firebase/firestore";
import { Functions, getFunctions } from "@firebase/functions";
import { FirebaseStorage, getStorage } from "@firebase/storage";

const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyC-1c6WWAsp0IbKb-uNfx0yOM5-Sr2yYtA",
  authDomain: "paragon-outdoor-usa.firebaseapp.com",
  projectId: "paragon-outdoor-usa",
  storageBucket: "paragon-outdoor-usa.appspot.com",
  messagingSenderId: "470951527633",
  appId: "1:470951527633:web:3f625cf20b0e0ff5a631f0"
};

const app = initializeApp(firebaseConfig);

export type Firebase = {
  app: FirebaseApp;
  auth: Auth;
  database: Database;
  firestore: Firestore;
  functions: Functions;
  storage: FirebaseStorage;
};

export const firebase: Firebase = {
  app,
  auth: initializeAuth(app, {
    persistence: browserLocalPersistence,
  }),
  database: getDatabase(app),
  firestore: getFirestore(app),
  functions: getFunctions(app),
  storage: getStorage(app),
};

export const projectId = firebaseConfig.projectId;
